import API from "../API";

export const AddToCartApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/cart`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateCartItemApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/cart/${payload?.cartItemId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const RemoveCartItemApi = async (payload) => {
  try {
    const response = await API.delete(
      `/ecommerce/cart/${payload?.cartItemId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const ClearCartApi = async () => {
  try {
    const response = await API.delete(`/ecommerce/clear/cart`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllCartItemApi = async (payload) => {
  try {
    const response = await API.get(`/ecommerce/cart`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetDeliveryChargeApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/delivery/charge?cod=${payload?.cod || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const magicFileUrlApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/v1/presigned-url?fileName=${payload?.fileName || ""}&contentType=${payload?.contentType || ""}&fileType=${payload?.fileType || ""}&userId=${payload?.userId || ""}&isAndroid=${false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const fileUploadCompleteApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/api/files/complete`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ContactUsApi = async (payload) => {
  try {
    const response = await API.post(`/common/contact-us`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
